<template>
    <div>

        <el-dialog title="接单状态" :visible.sync="orderVisible" width="1500px" @close="handleClose">
            <div class="">
                <div class="public_criteriaRange customerManagementPC-select">
                    <div class="public_oparetionBlock_Menu">
                        <label class="public_lbSty">接单车号:</label>
                        <div class="el-select public_optionSty">
                            <div class="el-input el-input--suffix">
                                <input style="padding-right: 10px;"
                                    class="el-input__inner pulic_carNumber" type="text" placeholder="请输入接单车号"
                                    v-model="carNumber" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="public_oparetionBlock_Menu"
                    style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
                    <el-button class="public_saleWater_chaxun" type="primary" @click="querycusList">搜索</el-button>
                    <el-button class="public_saleWater_chaxun" type="primary"
                        style="background-color: #20DA9C!important;border-color: transparent;" @click="reset">重置</el-button>
                </div>
            </div>
            <div class="billOperationRecord-table pulbic_table_container">
                <el-table tooltip-effect="dark" :data="tableData" style="width: 100%;"
                    :default-sort="{ prop: 'waterNum', order: 'descending' }" :header-cell-style="{
                        color: 'rgba(51,51,51,1)',
                        background: 'rgba(184,227,255,1)',
                        'font-weight': 'bold',
                    }" class="public_tableColumn">
                    <el-table-column prop="ORMTB470CA16" sortable fixed="left" width="110" label="接单时间">
                    </el-table-column>
                    <!-- <el-table-column prop="ORMTB470CA00" width="130" fixed="left" label="接单编号">
				</el-table-column> -->
                    <el-table-column prop="ORMTB470CA05" width="130" label="装货地">
                    </el-table-column>
                    <el-table-column prop="ORMTB470CA33" width="130" label="卸货地">
                    </el-table-column>
                    <el-table-column prop="ORMTB470CA40" width="100" label="发单人">
                    </el-table-column>
                    <el-table-column prop="ORMTB410CA04" width="100" label="货主">
                    </el-table-column>
                    <el-table-column prop="ORMTB470CA14" width="100" label="运费(每吨)">
                    </el-table-column>
                    <el-table-column v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'" prop="ORMTB470CA12" width="100"
                        label="接单人">
                        <template slot-scope="scope">
                            <p>
                                <span>{{ scope.row.ORMTB470CA12 }}</span>
                            </p>
                            <p style="color: #999;">
                                <span>{{ scope.row.ORMTB410CA02 }}</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(item, index) in tableHeadList" :width="item.width" :prop="item.prop"
                        :label="item.label" :key="index">
                    </el-table-column>
                    <el-table-column width="130" label="出厂结算金额">
                        <template slot-scope="scope">
                            <p>
                                <span v-if="scope.row.ORMTB470CA23">{{
                                    Number(scope.row.ORMTB470CA23 + scope.row.ORMTB470CA31).toFixed(
                                        '2'
                                    )
                                }}</span>
                                <span v-if="!scope.row.ORMTB470CA23"></span>
                            </p>
                        </template>
                    </el-table-column>
                    <!-- </el-table-column> -->
                    <el-table-column width="130" label="完成结算金额">
                        <template slot-scope="scope">
                            <p>
                                <span v-if="scope.row.ORMTB470CC06">{{
                                    Number(scope.row.ORMTB470CC06 + scope.row.ORMTB470CC07).toFixed(
                                        '2'
                                    ) || ''
                                }}</span>
                                <span v-if="!scope.row.ORMTB470CC06"></span>
                            </p>
                        </template>
                    </el-table-column>
                    <!-- </el-table-column> -->
                    <!-- <el-table-column prop="ORMTB470CA12" width="130" label="流水号">
					<template slot-scope="scope">
						<p>
							<span>{{ scope.row.ORMTB470CA24 }}</span>
						</p>

					</template>
				</el-table-column> -->
                    <el-table-column fixed="right" width="120" prop="ORMTB440CF01text" label="完成状态">
                        <template slot-scope="scope">{{
                            scope.row.ORMTB440CF01text
                            }}</template>
                    </el-table-column>

                    <el-table-column fixed="right" width="100" prop="auditText" label="申请状态">
                        <template slot-scope="scope">{{ scope.row.auditText }}</template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" prop="ORMTB470CN00" label="">
                        <template slot-scope="scope">
                            <img v-if="
                                scope.row.ORMTB470CN00 == '1' &&
                                uobj.pertb005.pertb005cb00 == 'CUS-1'
                            " class="imgStatistics" src="@/assets/images/orderStatistics/xg.png" />
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pulbic_pagesize">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
                        layout="total,sizes, prev, pager, next" :total="pagingPageMo">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            orderVisible: this.visible,
            carNumber: '',//接单车号
            tableData: [],
            pageMo: 1, //默认列表页码
            limitMo: 10, //每页的条数
            pagingPageMo: 0, //分页--数据列表共有的条数
            currentPage: 1, //设置当前页默认为1,
            uobj: this.$store.state.uobj, //登陆缓存--用户信息
            tableHeadList: [
                // {
                // 	prop: 'ORMTB440CA19',
                // 	label: '派单时间',
                // 	width: 110
                // },
                // {
                // 	prop: 'ORMTB440CA00',
                // 	label: '派单编号',
                // 	width: 130
                // },
                // {
                // 	prop: 'ORMTB440CA05',
                // 	label: '企业名称',
                // },
                // {
                // 	prop: 'ORMTB440CA03',
                // 	label: '客户名称',
                // },

                {
                    prop: 'ORMTB470CA01',
                    label: '接单车号',
                    width: 100,
                },
                {
                    prop: 'ORMTB470CA07',
                    label: '订单物料',
                    width: 100,
                },
                {
                    prop: 'ORMTB470CA19',
                    label: '出厂物料',
                    width: 100,
                },
                {
                    prop: 'ORMTB470CB02',
                    label: '接单重量',
                    width: 100,
                },
                {
                    prop: 'ORMTB470CA17',
                    label: '出厂结算时间',
                    width: 120,
                },
                {
                    prop: 'ORMTB470CC02',
                    label: '完成结算时间',
                    width: 120,
                },
                // {
                // 	prop: 'ORMTB470CA23',
                // 	label: '出厂结算金额',
                // 	width: 120
                // },
                // {
                // 	prop: 'ORMTB470CA23',
                // 	label: '完成结算金额',
                // 	width: 120
                // },
                // {
                // 	prop: 'ORMTB470CA24',
                // 	label: '流水号',
                // 	width: 130
                // }
                // {
                // 	prop: 'ORMTB440CF01text',
                // 	label: '完成状态',
                // 	width: 100
                // },
                // {
                // 	prop: 'auditText',
                // 	label: '申请状态',
                // 	width: 100
                // }
            ],
            tableHeadListInit: [
                {
                    prop: 'ORMTB470CA16',
                    label: '派单时间',
                },
                {
                    prop: 'ORMTB470CA00',
                    label: '派单编号',
                },
                {
                    prop: 'ORMTB470CA05',
                    label: '企业名称',
                },
                {
                    prop: 'ORMTB470CA12',
                    label: '客户名称',
                },

                {
                    prop: 'ORMTB470CA01',
                    label: '车牌号',
                },
                {
                    prop: 'ORMTB470CA07',
                    label: '订单物料',
                },
                {
                    prop: 'ORMTB440CC02',
                    label: '完成物料',
                },
                {
                    prop: 'ORMTB440CA10',
                    label: '重量',
                },
                {
                    prop: 'ORMTB440CF01text',
                    label: '完成状态',
                },
                {
                    prop: 'auditText',
                    label: '申请状态',
                },
            ],
        }
    },
    watch: {
        visible(newVal) {
            this.orderVisible = newVal;
            this.querycusList();
        }
    },
    methods: {
        reset(){
            this.carNumber = '';
            this.pageList();
        },
        handleSearch() {
            this.pageList();
        },
        querycusList() {
            this.pageList();
        },
        handleClose() {
            this.orderVisible = false;
            this.$emit('update:visible', false);
        },
        pageList() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB493ID:this.id,
                ORMTB470CA01: this.carNumber, //车牌号
                page: this.pageMo,
                limit: this.limitMo,
            }
            this.tableData = []
            var url = '/orm/ormtb470/selectPageListSL'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    // console.log(res)
                    if (res.data.code == 200) {
                        var data = res.data.data.dataList
                        // console.log(data)
                        this.pagingPageMo = res.data.count
                        for (var i = 0; i < data.length; i++) {
                            var customerName = ''
                            if (data[i]['ORMTB470CD00'] == '-1') {
                                data[i]['ORMTB440CF01text'] = '取消'
                            } else if (data[i]['ORMTB470CD00'] == '0') {
                                data[i]['ORMTB440CF01text'] = '已接单'
                            } else if (data[i]['ORMTB470CD00'] == '1') {
                                data[i]['ORMTB440CF01text'] = '提货中'
                            } else if (data[i]['ORMTB470CD00'] == '2') {
                                data[i]['ORMTB440CF01text'] = '已出厂结算'
                            } else if (data[i]['ORMTB470CD00'] == '3') {
                                data[i]['ORMTB440CF01text'] = '待审核磅单'
                            } else if (data[i]['ORMTB470CD00'] == '4') {
                                data[i]['ORMTB440CF01text'] = '已审核待确认'
                            } else if (data[i]['ORMTB470CD00'] == '5') {
                                data[i]['ORMTB440CF01text'] = '已完成'
                            } else if (data[i]['ORMTB470CD00'] == '-2') {
                                data[i]['ORMTB440CF01text'] = '申请取消'
                            } else if (data[i]['ORMTB470CD00'] == '-3') {
                                data[i]['ORMTB440CF01text'] = '磅单审核已拒绝'
                            }

                            if (data[i]['ORMTB470CD00'] == '-2') {
                                if (data[i]['ORMTB470CD01'] == '0') {
                                    data[i]['auditText'] = '未审核'
                                } else if (data[i]['ORMTB470CD01'] == '1') {
                                    data[i]['auditText'] = '通过'
                                } else if (data[i]['ORMTB470CD01'] == '2') {
                                    data[i]['auditText'] = '拒绝'
                                }
                            }

                            // else if (data[i]['ORMTB440CF01'] == '6') {
                            // 	data[i]['auditText'] = '未审核'
                            // }
                            else {
                                data[i]['auditText'] = '通过'
                                // if (data[i].ORMTB440CH00 == 0) {
                                // 	data[i].isauditOrder = 0
                                // }
                                // if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 0) {
                                // 	data[i].isauditOrder = 1
                                // }
                                // if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 1) {
                                // 	data[i].isauditOrder = 0
                                // }
                                // if (data[i]['ORMTB440CH01'] == '0') {
                                // 	data[i]['auditText'] = '未审核'
                                // } else if (data[i]['ORMTB440CH01'] == '1') {
                                // 	data[i]['auditText'] = '通过'
                                // } else if (data[i]['ORMTB440CH01'] == '2') {
                                // 	data[i]['auditText'] = '拒绝'
                                // }
                            }
                        }
                        this.tableData = data
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        handleSizeChange(val) {
            this.pageMo = 1
            this.limitMo = val
            this.pageList()
        },
        // 点击页码
        handleCurrentChange(val) {
            this.pageMo = val
            this.pageList()
        },
    }
}
</script>
<style scoped></style>
